<template>
  <div id="settingspage">

    <PageHeader></PageHeader>
    <div class="app__content-wrapper">
      <h2 class="white">{{ $t('settings_raster') }}</h2>

      <VueSlickCarousel v-bind="settings" class="settings-slider" @swipe="swipeAction"
                        @beforeChange="beforeChangeAction" @afterChange="aftereChangeAction">
        <div :class="[currrentGridId == 0 ? 'grid-active' : '', 'grid-slide']"   @click="selectGrid(0)" >
          <div class="nav-item-overlay-div"></div>
          <img draggable="false" src="../assets/static/grid_1x1.png" class="grid-image">
        </div>
        <div :class="[currrentGridId == 1 ? 'grid-active' : '', 'grid-slide']" @click="selectGrid(1)">
          <div class="nav-item-overlay-div"></div>
          <img draggable="false" src="../assets/static/grid_1x2.png" class="grid-image">
        </div>
        <div :class="[currrentGridId == 2 ? 'grid-active' : '', 'grid-slide']" @click="selectGrid(2)">
          <div class="nav-item-overlay-div"></div>
          <img draggable="false" src="../assets/static/grid_1x3.png" class="grid-image">
        </div>
        <div :class="[currrentGridId == 3 ? 'grid-active' : '', 'grid-slide']"  @click="selectGrid(3)">
          <div class="nav-item-overlay-div"></div>
          <img draggable="false" src="../assets/static/grid_2x2.png" class="grid-image">
        </div>

        <div :class="[currrentGridId == 4 ? 'grid-active' : '', 'grid-slide']"  @click="selectGrid(4)">
          <div class="nav-item-overlay-div"></div>
          <img draggable="false" src="../assets/static/comic_1x2x2x1.png" class="grid-image">
        </div>


        <div :class="[currrentGridId == 5 ? 'grid-active' : '', 'grid-slide']"  @click="selectGrid(5)">
          <div class="nav-item-overlay-div"></div>
          <img draggable="false" src="../assets/static/comic_2x1x2.png" class="grid-image">
        </div>

        <div :class="[currrentGridId == 6 ? 'grid-active' : '', 'grid-slide']"  @click="selectGrid(6)">
          <div class="nav-item-overlay-div"></div>
          <img draggable="false" src="../assets/static/comic_3x2.png" class="grid-image">
        </div>
      </VueSlickCarousel>
      <br>
      <router-link to="loading" class="button-big">{{ $t('global_next') }}</router-link>
      <br>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import PageHeader from './PageHeader'

export default {
  name: 'Settingspage',
  components: {
    VueSlickCarousel,
    PageHeader
  },
  data: () => {
    return {
      showDelayed: false,
      currrentGridId: 0,
      settings: {
        slidesToShow: 4,
        infinite: false,
        dots: true,
        responsive: [
          {
            breakpoint: 1160,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3

            }
          },
          {
            breakpoint: 910,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2

            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1

            }
          }
        ]

      }
    }
  },
  created () {
    setTimeout(() => {
      window.track('Settingspage')
      this.showDelayed = true
    }, 1000)
  },
  methods: {
    showNext () {
      this.$refs.carousel.next()
    },
    selectGrid (gridId) {
      window.track('Settingspage', 'Grid Select')
      this.currrentGridId = gridId
      this.$store.dispatch('updateGrid', gridId)
    },
    beforeChangeAction () {

    },
    aftereChangeAction () {
      this.sliderClickable = true
    },
    swipeAction () {
      this.sliderClickable = false
    }
  },
  computed: {
    title: {
      get () {
        return this.$store.state.title
      },
      set (value) {
        this.$store.dispatch('updateTitle', value)
      }
    }
  }

}
</script>

<style lang="scss" scoped>

  .grid-slide {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    box-sizing: border-box;
    border: 2px solid transparent;
  }

  .grid-image {
    width: auto;
    height: 285px;
    margin: 0 auto;
    pointer-events: none;
    cursor: pointer;
    @media (hover: hover) {
      pointer-events: auto;
    }
  }
  .nav-item-overlay-div{
    position: absolute;
    height: 100%;
    width:100%;
    background-color: transparent;
  }

</style>
<style lang="scss">
  .slick-next {
    //right:0 !important;
  }

  .slick-prev {
    // left:0 !important;
  }

  #settingspage {
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
  }

  .settings-slider {
    width: 80%;
    margin: 0 auto;
    height: 300px;
    padding: 5px;
    box-sizing: border-box;
    margin-top: 5em;
    margin-bottom: 1.5em;
  }

  .title-input {
    outline: none;
    font-size: 1.2em;
    box-sizing: border-box;
    border: 1px solid white;
    padding: 4px;
    color: white;
    background-color: rgba(0, 0, 0, 0);
    font-family: 'Bangers', 'Alegreya Sans', cursive;
    text-align: center;
    font-size: 2em;
    width: 90%;
    max-width: 500px;
    padding: 0.5em;
  }
</style>
